import { render, staticRenderFns } from "./global-art-toy-design-contest.vue?vue&type=template&id=6d7e1955&scoped=true&"
import script from "./global-art-toy-design-contest.vue?vue&type=script&lang=js&"
export * from "./global-art-toy-design-contest.vue?vue&type=script&lang=js&"
import style0 from "./global-art-toy-design-contest.vue?vue&type=style&index=0&id=6d7e1955&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7e1955",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Atlas: require('/var/jenkins_home/workspace/prod-web-xfans/components/atlas.vue').default})
